export const name = "DATE_FROM_UNIX_DATE";
export const summary = `Interprets an \`INT64\` expression as the number of days since 1970-01-01.`;
export const reference = `
## DATE_FROM_UNIX_DATE

Interprets an \`INT64\` expression as the number of days since 1970-01-01.

\`\`\`
DATE_FROM_UNIX_DATE(int64_expression)
\`\`\`

### Description

Interprets \`int64_expression\` as the number of days since 1970-01-01.


### Return Data Type

DATE


### Example



\`\`\`
SELECT DATE_FROM_UNIX_DATE(14238) AS date_from_epoch;

/*-----------------*
 | date_from_epoch |
 +-----------------+
 | 2008-12-25 |
 *-----------------+*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions
`;
